import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04bb4211"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center mt-2 mb-2"
}
const _hoisted_2 = ["alt"]
const _hoisted_3 = { class: "d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "lead text-muted mb-0" }
const _hoisted_5 = { class: "m-0" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-bold" }
const _hoisted_8 = { class: "mr-1 text-bold lead" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle text-success message-icon mr-2" }, null, -1))
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle text-primary message-icon mr-2" }, null, -1))
const _hoisted_13 = {
  key: 4,
  class: "mt-3"
}
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "p-field-checkbox form-group mt-1" }
const _hoisted_17 = ["for"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"1.5rem"}
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "ml-2" }
const _hoisted_22 = ["for"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "mr-1 text-bold lead" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_TrainingDetailSummary = _resolveComponent("TrainingDetailSummary")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BackButton, {
      label: _ctx.$t('myCadac.trainingDetail.button.back')
    }, null, 8, ["label"]),
    (_ctx.vm.training)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("img", {
            alt: _ctx.vm.training.productIconAlt,
            class: "icon-training-item mr-2"
          }, null, 8, _hoisted_2), [
            [_directive_lazy, _ctx.vm.training.productIconUrl]
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.vm.training.brand), 1),
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.vm.training.name), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_TrainingDetailSummary, {
      "is-instructor": _ctx.vm.isInstructor,
      vm: _ctx.vm.training
    }, {
      default: _withCtx(() => [
        (_ctx.vm.isParticipant)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("myCadac.trainingSummary.lblPresence")), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.attendancePercentage(_ctx.userAsParticipant) || 0) + "%", 1),
              _createTextVNode(" | "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.training.dates, (date, dateIndex) => {
                return (_openBlock(), _createBlock(_component_Chip, {
                  key: date,
                  class: _normalizeClass(_ctx.isParticipantPresentForDay(_ctx.userAsParticipant, dateIndex) ? 'text-success' : 'text-danger'),
                  icon: _ctx.isParticipantPresentForDay(_ctx.userAsParticipant, dateIndex) ? 'pi pi-check' : 'pi pi-times',
                  label: _ctx.formatDate(date.date)
                }, null, 8, ["class", "icon", "label"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-instructor", "vm"]),
    (_ctx.vm.isParticipant && _ctx.canDownloadCertificate(_ctx.userAsParticipant))
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 1,
          class: "message-with-button",
          closable: false,
          severity: "custom"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.message.canDownloadCertificate")), 1)
            ]),
            _createVNode(_component_Button, {
              class: "p-button-text p-button-raised m-1",
              icon: "pi pi-download",
              label: _ctx.$t('myCadac.trainingDetail.button.downloadCertificate'),
              title: _ctx.$t('myCadac.trainingDetail.button.downloadCertificate_title'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadCertificate(_ctx.userAsParticipant)))
            }, null, 8, ["label", "title"])
          ]),
          _: 1
        }))
      : (_ctx.vm.isParticipant && !_ctx.canDownloadCertificate(_ctx.userAsParticipant))
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 2,
            closable: false,
            severity: "warn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("myCadac.trainingDetail.message.cannotDownloadCertificate")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (_ctx.canDownloadAllCertificates)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 3,
          class: "message-with-button",
          closable: false,
          severity: "custom"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.message.instructorDownloadAllCertificates")), 1)
            ]),
            _createVNode(_component_Button, {
              class: "p-button-text p-button-raised m-1",
              icon: "pi pi-download",
              label: _ctx.$t('myCadac.trainingDetail.button.downloadAllCertificates'),
              title: _ctx.$t('myCadac.trainingDetail.button.downloadAllCertificates_title'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadAllCertificates()))
            }, null, 8, ["label", "title"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ((_ctx.vm.isInstructor || _ctx.vm.isCustomer) && _ctx.vm.training?.participants)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.vm.isInstructor
					? _ctx.$t("myCadac.trainingDetail.titleUpdateAttendance")
					: _ctx.$t("myCadac.trainingDetail.titleAttendance")), 1),
          _createVNode(_component_DataTable, {
            "auto-layout": "",
            "data-key": "id",
            value: _ctx.trainingParticipants
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                key: "participant",
                "body-class": "",
                header: _ctx.$t('myCadac.trainingDetail.table.participant')
              }, {
                body: _withCtx((item) => [
                  _createTextVNode(_toDisplayString(_ctx.participantName(item.data)), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                key: "email",
                field: "email",
                header: _ctx.$t('myCadac.trainingDetail.table.email')
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                key: "allPresenceDays",
                field: "allPresenceDays",
                header: _ctx.$t('myCadac.trainingDetail.table.presence')
              }, {
                body: _withCtx((item) => [
                  (_ctx.vm.isInstructor)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_Checkbox, {
                              modelValue: _ctx.participantAllDayPresent[item.data.id],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.participantAllDayPresent[item.data.id]) = $event),
                              id: `allDaysPresent-${item.index}`,
                              binary: true,
                              disabled: _ctx.isSpinnerVisible(item.data.id),
                              onClick: ($event: any) => (_ctx.toggleAllDatesPresent(item.data, item.index))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled", "onClick"]),
                            _createElementVNode("label", {
                              class: "ml-2 mb-0",
                              for: `allDaysPresent-${item.index}`
                            }, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.lblAllDaysPresent")), 9, _hoisted_17)
                          ]),
                          (_ctx.isSpinnerVisible(item.data.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.training.dates, (date, dateIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: date,
                              class: "p-field-checkbox form-group mt-1"
                            }, [
                              _createVNode(_component_Checkbox, {
                                modelValue: item.data.allPresenceDays[dateIndex],
                                "onUpdate:modelValue": ($event: any) => ((item.data.allPresenceDays[dateIndex]) = $event),
                                id: `dateCheckbox-${item.index}-${dateIndex}`,
                                binary: true,
                                disabled: _ctx.isSpinnerVisible(item.data.id),
                                onChange: ($event: any) => (_ctx.toggleDatePresent(item.data))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled", "onChange"]),
                              _createElementVNode("label", {
                                class: "ml-2 mb-0",
                                for: `dateCheckbox-${item.index}-${dateIndex}`
                              }, _toDisplayString(_ctx.formatDate(date.date)), 9, _hoisted_22)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.attendancePercentage(item.data) || 0) + "%", 1),
                        _createTextVNode(" | "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.training.dates, (date, dateIndex) => {
                          return (_openBlock(), _createBlock(_component_Chip, {
                            key: date,
                            class: _normalizeClass(
								_ctx.isParticipantPresentForDay(item.data, dateIndex) ? 'text-success' : 'text-danger'
							),
                            icon: 
								_ctx.isParticipantPresentForDay(item.data, dateIndex) ? 'pi pi-check' : 'pi pi-times'
							,
                            label: _ctx.formatDate(date.date)
                          }, null, 8, ["class", "icon", "label"]))
                        }), 128))
                      ]))
                ]),
                _: 1
              }, 8, ["header"]),
              (_ctx.vm.isCustomer)
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: "certificate",
                    "body-class": "",
                    header: _ctx.$t('myCadac.trainingDetail.table.certificate')
                  }, {
                    body: _withCtx((item) => [
                      (_ctx.canDownloadCertificate(item.data))
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "p-button-text p-button-raised p-button-rounded",
                            icon: "pi pi-download",
                            label: _ctx.isSmallScreen ? _ctx.$t('myCadac.trainingDetail.button.downloadCertificate') : '',
                            title: _ctx.$t('myCadac.trainingDetail.button.downloadCertificate_title'),
                            onClick: ($event: any) => (_ctx.downloadCertificate(item.data))
                          }, null, 8, ["label", "title", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}